import baseBackendApi from "../configuration/baseBackendApi";

export const loginPost = async (email, password) => {
    const response = await baseBackendApi.post('auth/login', { email, password });
    return response.data;
}